<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'commodity',
      key:'id',
       url: {
          get:'/admin/commodity',
        },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        {
          label: '商品名称',
          name: 'commodityName',
          value: '',
          type: 'input',
          width:'300px',
          rules: [{ required: true, trigger: 'blur', }],
        },
        {
          label: '商品分类',
          name: 'commodityTypeId',
          value: '',
          type: 'select',
          width:'300px',
          dropList: [],
          rules: [{ required: true, trigger: 'blur',type:'number', }],
        },
        {
          label: "商品品牌",
          name: "brand",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "商品型号",
          name: "model",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "适用机型/场景",
          name: "enableModelScen",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "功能",
          name: "enableFunction",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "商品标签",
          name: "labelIdList",
          value: "",
          type: "multiple",
          width: "300px",
          dropList: [],
          onChange: this.onCouponAlis,
          // rules: [{ required: true}],
        },
        {
          label: "图片",
          name: "commodityImage",
          value: "",
          type: "image",
          desc: "图片尺寸最低750*420像素比例",
          rules: [{trigger: "blur" }],
        },
        {
          label: "轮播图",
          name: "carouselChart",
          value: "",
          type: "gallery",
          desc: "图片尺寸最低750*420像素比例",
          rules: [{ trigger: "blur",}],
        },
        // {
        //   label: "商品详情",
        //   name: "detailChart",
        //   value: "",
        //   type: "image",
        //   desc: "图片尺寸最低750*420像素比例",
        //   rules: [{ trigger: "blur",}],
        // },
        // { label: '商品编号', name: 'commodityNumber', value: '', type: 'input',width:'300px'},
        { label: '商品价格', name: 'commodityPrice', value: '', type: 'input',width:'300px',rules: [{ required: true, trigger: "blur" }],},
        {
          label: "商品京东价",
          name: "jdPrice",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        { label: '商品进价', name: 'commodityCost', value: '', type: 'input',width:'300px', rules: [{ required: true, trigger: "blur" }],},

        // { label: "状态", name: "status", value: 1, type: "switch", trueValue: 1, falseValue: 0 },
      ],
      forms: {
        id:"",
        createBy:$utils.data.get("auth", "customer")
      },
    }
  },
  created() {
    this.loadLevelData()
  },
  methods: {
    onCouponAlis(val) {
      let ass = val.join(",");
      this.value = ass;
    },


    loadLevelData: function () {
      // 通过pk查询字典数据
      let qq = {}
      $utils.api.load('/admin/commodityType/list', qq).then((res) => {
        if (res && res.rows) {
          let ll = res.rows
          let dropList = []
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index]
            let xx = {}
            xx.value = element.id
            xx.name = element.commodityType
            xx.children = element.children || []
            dropList.push(xx)
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index]
            if (element && element.name == 'commodityTypeId') {
              // this.items[index]['dropList'] = dropList
              this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
            }
          }
        }
      })

      // 通过pk查询字典数据
      let q = {}
      $utils.api.load('/admin/labelType/list', q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows
          let dropList = []
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index]
            let xx = {}

            xx.value = element.id
            xx.name = element.labelName
            xx.children = element.children || []

            dropList.push(xx)
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index]
            if (element && element.name == 'labelIdList') {
              // this.items[index]['dropList'] = dropList
              this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
            }
          }
        }
      })

    },
    // handleSubmit() {
    //   if (!this.action) {
    //     return true
    //   }
    //   let q = this.forms
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       this.sloading = true
    //       $utils.api
    //         .load(`/admin/commodity/update`, q, 'POST')
    //         .then((res) => {
    //           this.sloading = false
    //           if (res.status) {
    //             $utils.toast.success('保存成功')
    //             $utils.url.go(-1)
    //           }
    //         })
    //         .catch((e) => {
    //           this.sloading = false
    //           $utils.toast.error('保存异常' + e.message)
    //         })
    //     }
    //   })
    // },
      handleSubmit() {
      if (!this.action) {
        return true
      }
      const action=this.$route.query.action
        this.forms.id=this.$route.query.kv
        if (this.forms.labelIdList != undefined) {
          this.forms.labelId=this.forms.labelIdList.join(",")
        }
        let q = this.forms
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true
          if(action=='edit'){
            $utils.api
                .load(`/admin/commodity/update`, q,  'POST')
                .then((res) => {
                  this.sloading = false
                  if (res.status) {
                    $utils.toast.success('保存成功')
                    $utils.url.go(-1)
                  }
                })
                .catch((e) => {
                  this.sloading = false
                  $utils.toast.error('保存异常' + e.message)
                })
          }else{ $utils.api
              .load(`/admin/commodity/add`, q,  'POST')
              .then((res) => {
                this.sloading = false
                if (res.status) {
                  $utils.toast.success('保存成功')
                  $utils.url.go(-1)
                }
              })
              .catch((e) => {
                this.sloading = false
                $utils.toast.error('保存异常' + e.message)
              })}
        }
      })
    },
  },
}
</script>
